module.exports = __webpack_public_path__ + "img/5.d8bac9d3.svg";